export class MaalerDto {
    public info1: string;
    public info2: string;
    public maalerNr: string;
    public typeNr: number;
    public opsatDato: string;
    public sidsteService: string;
}
